import React, { useState } from 'react'
import './pricing-table.styles.scss';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ImageContainer from '../image-container/image-container.component';
import PricingModal from './pricing-modal.component';

const PricingTable = () => {

    const currentUser = useSelector(state => state.userData.currentUser);
    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ level, setLevel ] = useState(null);
    const navigate = useNavigate();

    function launchPurchase(e) {
        if (e === 'premium') {
            window.open(
                `${import.meta.env.VITE_PREMIUM_LINK_LIVE}${currentUser ? `?prefilled_email=${currentUser.email}` : ''}`,
                 '_new');
        } else {
            window.open(import.meta.env.VITE_PRO_LINK_LIVE, '_new');
        }
    }

    function handleClick(e) {
        if (!currentUser) {
            const encoded = encodeURIComponent('/pricing');
            navigate('/signin?successUrl=' + encoded);
            return;
        }
        setLevel(e);
    }

    return (
        <div className={`pricing-table-container ${screenSize}`}>
            <div className='pricing-table-content'>
                <div className={`g-card pricing-card ${membership && membership.membership === 0 ? `current-membership` : ''}`}>
                    <ImageContainer src='/images/icons/free.png' className='pricing-icon' />
                    <div className="g-space-1"></div>
                    <div className='card-title'>
                        Basic Plan
                    </div>
                    <p className='meta'>For users getting started</p>
                    <div className="g-space-0-5"></div>
                    <div className='card-title'>
                        Free
                    </div>
                    <div className="g-space-1"></div>
                    <Link 
                        to="/signin" 
                        className={
                            (
                                membership &&
                                membership.membership > 0
                            ) ? 'no-click' : ''
                        }
                    >
                        <button className={`g-button med-btn ${
                            (
                                membership &&
                                membership.membership > 0
                            ) ? 'disabled' : ''
                        }`} >
                            Continue For Free
                        </button>
                    </Link>
                    <div className="g-space-1"></div>
                    <ul>
                        <li>2 Active Games</li>
                        <li>2 Available Game Styles: Points and a Leaderboard or Currency and a Store</li>
                        <li>Up to 50 Game Elements per Game</li>
                        <li>Up to 50 Players/Teams per Game</li>
                        {/* <li>Access to Basic Game Templates</li> */}
                        
                    </ul>
                    
                </div>
                <div className={`g-card pricing-card ${membership && membership.membership === 1 ? `current-membership` : ''}`}>   
                    <ImageContainer src='/images/icons/pro.png' className='pricing-icon' />
                    <div className="g-space-1"></div>
                    <div className='card-title'>
                        Pro Plan
                    </div>
                    <p className='meta'>Level up your gamification</p>
                    <div className="g-space-0-5"></div>
                    <div className='card-title'>
                        <span>$3</span><span className='meta'>per month or </span>
                        <span>$29</span><span className='meta'>annually</span>
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (membership && membership.membership === 1) 
                        ?
                        <button className='g-button med-btn primary no-click' >
                            Purchased!
                        </button>
                        :
                        (membership && membership.membership > 0)
                        ?
                        <button 
                            className='g-button med-btn disabled' 
                            onClick={() => null} >
                            Purchase Plan
                        </button>
                        :
                        <button
                            className='g-button med-btn'
                            onClick={() => handleClick('pro')} >
                            Purchase Plan
                        </button>
                    }
                    <div className="g-space-1"></div>
                    <ul>
                        <li>10 Active Games</li>
                        {/* <li>$10 per Additional Game</li> */}
                        {/* <li>No Restricted Game Styles</li> */}
                        <li>Up to 200 Players/Teams per Game</li>
                        <li>Up to 200 Game Elements per Game</li>
                        <li>Access to Premium Features like Challenges, Collectibles, Prize Packs, Lotteries, and more!</li>
                        {/* <li>Access to All Game Templates</li> */}
                        
                    </ul>
                </div>
                <div className={`g-card pricing-card ${membership && membership.membership === 2 ? `current-membership` : ''}`}>   
                    <ImageContainer 
                        src='/images/icons/premium.png' 
                        className='pricing-icon' />
                    <div className="g-space-1"></div>
                    <div className='card-title'>
                        Premium Plan
                    </div>
                    <p className='meta'>For hardcore gamifiers</p>
                    <div className="g-space-0-5"></div>
                    <div className='card-title'>
                        <span>$6</span><span className='meta'>per month or </span>
                        <span>$59</span><span className='meta'>annually</span>
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (membership && membership.membership >= 2) 
                        ?
                        <button className='g-button med-btn disabled' >
                            Purchase Plan
                        </button> 
                        :
                        (membership && membership.membership === 2)
                        ?
                        <button className='g-button med-btn primary  no-click' >
                            Purchased!
                        </button>
                        :
                        <button 
                            className='g-button med-btn'
                            onClick={() => handleClick('premium')} >
                            Purchase Plan
                        </button>                
                    }
                    <div className="g-space-1"></div>
                    <ul>
                        <li>10 Active Games</li>
                        {/* <li>$5 per Additional Game</li> */}
                        {/* <li>No Restricted Game Styles</li> */}
                        <li>Up to 1,000 Players/Teams per Game</li>
                        <li>UNLIMITED Game Elements per Game</li>
                        <li>Access to Premium Features like Challenges, Collectibles, Prize Packs, Lotteries, and more!</li>
                        {/* <li>Access to All Game Templates</li> */}
                        
                    </ul>
                </div>
                <div className={`g-card pricing-card ${membership && membership.membership === 3 ? `current-membership` : ''}`}>   
                    <ImageContainer src='/images/icons/enterprise.png' className='pricing-icon' />
                    <div className="g-space-1"></div>
                    <div className='card-title'>
                        Enterprise Plan
                    </div>
                    <p className='meta'>For organizations</p>
                    <div className="g-space-0-5"></div>
                    <div className='card-title'>
                        Contact Us
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (membership && membership.membership > 2) 
                        ?
                        <button className='g-button med-btn primary no-click' >
                            Activated!
                        </button>
                        :
                        <Link to="/quote">
                            <button className='g-button med-btn' >
                                Request a Quote
                            </button>
                        </Link>
                    }
                    <div className="g-space-1"></div>
                    <ul>
                        <li>UNLIMITED Games</li>
                        <li>Multiple Managers Per Game</li>
                        <li>Shared Game Content</li>
                        <li>UNLIMITED Players/Teams per Game</li>
                        <li>UNLIMITED Game Elements per Game</li>
                        <li>Access to Premium Features like Challenges, Collectibles, Prize Packs, Lotteries, and more!</li>
                        {/* <li>Access to All Game Templates</li> */}
                        
                    </ul>
                </div>
            </div>
            <PricingModal
                level={level}
                cancel={() => setLevel(null)} />
        </div>
    )
}

export default PricingTable